import { FC } from 'react';
import { Chip } from '@mui/material';
import { IChipProps } from './types';

const Chips: FC<IChipProps> = ({ color, label }) => {
  return <Chip color={color} label={label}/>;
};

export default Chips;
